import leftBgImage from '../assets/background.webp';
import rightBgImage from '../assets/background.webp';

const Background = () => {

  return (
    <div>
      {/* First left image */}
      <div className="left-bg" style={{
        position: 'fixed',
        left: '-15%',
        top: '-10%',
        width: '80%',
        height: '200%',
        backgroundImage: `url(${leftBgImage})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left center',
        opacity: 0.3,
        zIndex: -1,
      }} />
      {/* First right image */}
      <div className="right-bg" style={{
        position: 'fixed',
        right: '-15%',
        top: '-15%',
        width: '80%',
        height: '200%',
        backgroundImage: `url(${rightBgImage})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right center',
        opacity: 0.3,
        zIndex: -1,
      }} />
    </div>
  );

};

export default Background;
